// SeoLinkTagsHelmet.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { UTM_WHITE_LIST } from '../resource/fetchOptionHeader.js';
import { alternateDomainMap } from '../resource/seoConstants.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

export const SeoLinkTagsHelmet = ({
  url = '',
  availableLanguages = EMPTY_ARRAY,
  currentLanguage = '',
  xDefaultLanguage = 'zh-TW',
}) => {
  const location = useLocation();
  if (!url) return null;

  const minimalUrl = new URL(`${url}${location?.search}`);
  const minimalUrlSearchParams = minimalUrl.searchParams;
  [...minimalUrlSearchParams.keys()].forEach(key => {
    if (!UTM_WHITE_LIST.includes(key)) {
      minimalUrlSearchParams.delete(key);
    }
  });
  const urlWithUserLang = new URL(minimalUrl.href);
  urlWithUserLang.hostname =
    alternateDomainMap[currentLanguage.toLowerCase()] ||
    alternateDomainMap.default;
  urlWithUserLang.searchParams.set('lang', currentLanguage);

  const urlWithXDefaultLang = new URL(minimalUrl.href);
  urlWithXDefaultLang.hostname = alternateDomainMap.default;
  urlWithXDefaultLang.searchParams.set('lang', xDefaultLanguage);

  return (
    <Helmet>
      <link rel="canonical" href={urlWithUserLang.href} />
      <link
        rel="alternate"
        hrefLang="x-default"
        href={urlWithXDefaultLang.href}
      />
      {availableLanguages.map(lang => {
        const url = new URL(minimalUrl.href);
        url.hostname =
          alternateDomainMap[lang.toLowerCase()] || alternateDomainMap.default;
        if (lang.toLowerCase() === 'zh-hant') {
          url.searchParams.set('lang', 'zh-TW');
          return (
            <React.Fragment key={lang}>
              <link rel="alternate" hrefLang={lang} href={url.href} />
              <link rel="alternate" hrefLang="'zh-TW'" href={url.href} />
            </React.Fragment>
          );
        } else {
          url.searchParams.set('lang', lang);
          return (
            <link key={lang} rel="alternate" hrefLang={lang} href={url.href} />
          );
        }
      })}
    </Helmet>
  );
};

SeoLinkTagsHelmet.propTypes = {
  url: PropTypes.string,
  currentLanguage: PropTypes.string,
  availableLanguages: PropTypes.array,
  xDefaultLanguage: PropTypes.string,
};

export default SeoLinkTagsHelmet;
